import {
  Box, Button, Card, Paper, Stack, Tooltip, Typography, FormControl, InputLabel,
  Select, MenuItem, TextField, IconButton, Modal,
  Menu
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import CommonGridHeader, { CommonPatientCard, CommonPatientDetails, ConsultantPatientCard, DeletePopup, OpenWebCamPopUP, CommonDeleteButton } from '../../../../../Components/Common Components/CommonComponents'
import { withTranslation } from 'react-i18next'
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../../Utility/API/Serviceurls'
import { getCachevalue,localGetItem } from '../../../../../Utility/Services/CacheProviderService'
import { Colors } from '../../../../../Styles/Colors'
import '../ClinicalNotes/DoctorNotes.css';
import { DateTime } from 'luxon';
import Loader from '../../../../../Components/Loader';
import { CheckAccessFunc, dataURItoFile, fetchAndConvertToBase64 } from '../../../../../Components/CommonFunctions/CommonFunctions'
// import CommonDatePicker from '../../../../../Components/Common Components/CommonDatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { ImagePaths } from "../../../../../Utility/ImagePaths";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import PrintPreviewPop from '../../../../../Components/Common Components/PrintPreviewPop'
import MoreVertIcon from '@mui/icons-material/MoreVert';


let to_date = new Date();

let reportType = [
  { label: "Laboratory", value: "Laboratory" },
  { label: "Radiology", value: "Radiology" },
  { label: "Special", value: "Special" },
  { label: "Eye Test", value: "Eye Test" },
  { label: "Investigation", value: "Investigation" }
];

class IPTestReports extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ipPatientData: {},
      TestReportsData: [],
      page: 0,
      pageSize: 10,
      // fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      // toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      // dateIndex: 1,
      reportDetails: {},
      date: to_date,
      imgCapClked: false,
      CapturedImg: null,
      imgUpload: [],
      selectedImage: null,
      viewData: [],
      viewImage: null,
      currentIndex: 0,
      deletedPopup: false,
      deleteId: null,
      printPreviewPop: false,
      printPreviewData: [],
      pdfName: '',
      selectedRow: null,
    }
    this.uploadImage = React.createRef();
  }

  GetTestReports = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_TEST_REPORT + "?patient_id=" + this.state.ipPatientData?.patient_id + "&from_ip=true")
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({
              TestReportsData: response.data.data
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    }, () => {
      setTimeout(() => {
        this.setState({ isErrorMsg: false })
      }, 2000);
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    }, () => {
      setTimeout(() => {
        this.setState({ successMsg: false })
      }, 1500);
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  LoaderFunction = (key = false) => {
    this.setState({
      isLoader: key
    })
  }

  FilterDate = (from, to, index) => {
    this.setState({
      fromDate: from,
      toDate: to,
      dateIndex: index
    }, () => {

    })
  }

  componentDidMount() {
    let ipPatientData = getCachevalue("IppatientData")
    let patientData = JSON.parse(ipPatientData)
    this.setState({
      ipPatientData: patientData
    }, () => {
      this.GetTestReports()
    })
  }
   getFoRadiologyTestReportPrint = (resultSummaryId,radialogyId,paymentStatus) => {
      try {
        RestAPIService.getAll((localGetItem("isNewBilling") === "true" ? Serviceurls.NEW_RAD_RESULT_PRINT : Serviceurls.RAD_RESULT_PRINT) + '?id=' + resultSummaryId + "&radiology_id=" + radialogyId)
          .then((response) => {
              const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
              const fileURL = URL.createObjectURL(file);
              window.open(fileURL);
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.responseSuccessErrorMessage(error.response.data.message)
            } else {
              this.responseSuccessErrorMessage(error.message)
            }
          })
      } catch (error) {
        this.responseSuccessErrorMessage(error.message, false);
      }
    }

  getFoLabTestReportPrint = (resultSummaryId, labId) => {
    try {
      RestAPIService.getAll(Serviceurls.LAB_PATIENT_RESULT_PRINT + `?result_summary_id=${resultSummaryId}&laboratory_id=${labId}`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message);
    }
  }

  async getS3Key(doc_key) {
    try {
      const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));

      if (response.data.status === "success") {
        const Data = response.data;
        return {
          data_url: Data.data
        };
      }
    } catch (e) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: "Error fetching S3 URL"
      });
    }
  }

  async renderImage(imageData, pdfData) {
    let tempArr = [];
    if (imageData.length > 0) {
      for (let i = 0; i < imageData.length; i++) {
        let image = imageData[i].result_img_url
        if (image !== null) {
          let doc_key = image;
          let getData = await this.getS3Key(doc_key)
          getData["type"] = "image";
          tempArr.push(getData)
        }
      }
    }
    this.setState({
      viewData: tempArr,
      viewImage: tempArr[0]
    }, () => {
      if (pdfData?.length > 0 || pdfData === true) {
        window.open(this.state.viewImage.data_url)
      }
    })
  }

  prevImage = (index) => {

    let { viewData } = this.state;

    let currentIndex = parseInt(index) || 0;

    if (currentIndex >= 1) {
      this.setState({
        currentIndex: currentIndex - 1,
        viewImage: viewData[currentIndex - 1]
      })
    }
  }

  nextImage = (index) => {

    let { viewData } = this.state;

    let currentIndex = parseInt(index) || 0;

    if ((currentIndex + 1) < viewData.length) {
      this.setState({
        currentIndex: currentIndex + 1,
        viewImage: viewData[currentIndex + 1]
      })
    }
  }

  popUpViewClose = () => {
    this.setState({
      isViewClicked: false,
      viewOpen: false,
      currentIndex: 0,
      viewData: [],
      viewImage: null
    })
  }

  handleDelete = (data) => {
    this.setState({
      deletedPopup: true,
      deleteId: data?.id,
    })
  }

  PopupClose = () => {
    this.setState({
      deletedPopup: false,
      deleteId: null,
    })
  }

  removeDataList = () => {
    try {
      RestAPIService.delete(`${Serviceurls.FO_TEST_REPORT_DELETE}?id=${this.state.deleteId}`)
        .then(response => {
          if (response.data.status === "success") {
            this.PopupClose();
            this.successMessage(response.data.message);
            this.GetTestReports();
          }
        })
        .catch(e => {
          this.errorMessage((e?.response?.data?.message || e?.message))
        });
    } catch (e) {
      this.errorMessage(e.message);
    }
  }

   moreActionOption = (data) => {
        const multi_option = [
          { label: "View Document", value: "viewDocument" },
        ];
        return (
          <div>
            <Tooltip title={"More"} placement='top' arrow>
              <IconButton
                onClick={(e) => {
                  this.setState({
                    anchorEl: e.currentTarget,
                    selectedRow: data.id,
                    isSelected: true
                  })
                }}
              >
                <MoreVertIcon />
              </IconButton>
            </Tooltip>
            {(this.state.isSelected && this.state.selectedRow == data.id) ?
              <Menu
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={() => {
                  this.setState({ anchorEl: null })
                }}
              >
                {multi_option.map((option) => (
                  <MenuItem key={option}
                    disabled={option.value === "viewDocument" ? !(data?.result_document?.length > 0) : false}
                    onClick={() => {
                      if (option.value === "viewDocument") {
                        this.getS3Keys(data?.result_document)
                      }
                    }}>
                    {option.label}
                  </MenuItem>
                ))}
              </Menu> : null}
          </div>
        )
      }
  
    async getS3Keys(documents) {
        try {
          if (!documents || documents.length === 0) return;
    
          let previewItems = [];
    
          for (const doc of documents) {
            const docName = doc.document_name;
            const docKey = doc.document_file;
    
            const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(docKey));
    
            if (response.data.status === "success") {
              const fileUrl = response?.data?.data;
              if (docName.toLowerCase().includes("jpg")) {
                // Fetch image and convert to blob object URL
                const fileResponse = await fetch(fileUrl);
                const blob = await fileResponse.blob();
                const imageUrl = URL.createObjectURL(blob);
                previewItems.push({ type: "image", url: imageUrl, name: docName });
              } else {
                // PDF or other formats
                const base64 = await fetchAndConvertToBase64(fileUrl);
    
                const pdfBase64 = base64.replace(
                  "data:binary/octet-stream;",
                  "data:application/pdf;"
                );
    
                previewItems.push({ type: "pdf", url: pdfBase64, name: docName });
              }
            }
          }
    
          this.setState({
            printPreviewPop: true,
            printPreviewData: previewItems,
            pdfName: "Result Preview"
          });
    
        } catch (e) {
          this.responseSuccessErrorMessage((e?.response?.data?.message || e?.message), false)
        }
      }
  
      closePrintPreview = () => {
      this.setState({
        printPreviewPop: false,
        printPreviewData: [],
        pdfName: ''
      })
    }

  renderLeftContent = () => {
    this.state.TestReportsData.forEach((element, index) => element.sno = index + 1)
    const { t } = this.props
    const columns = [
      {
        field: "report_date", headerName: "Date", flex: 0.15, headerAlign: "center", align: "center",
        renderCell: (params) => {
          return (
            <Box component={'div'}>{params?.row?.report_date ? params?.row?.report_date.length > 10 ?
              <Tooltip arrow title={params?.row?.report_date} placement='top'>
                <div>{params?.row?.report_date.slice(0, 10) + '...'}</div>
              </Tooltip> :
              params?.row?.report_date : "-"}</Box>
          )
        }
      },
      {
        field: "report_type", headerName: "Reports Type", flex: 0.2, headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>{params?.row?.report_type ? params?.row?.report_type.length > 10 ?
          <Tooltip arrow title={params?.row?.report_type} placement='top'><div>{params?.row?.report_type.slice(0, 10) + '...'}</div></Tooltip> : params?.row?.report_type : "-"}</Box>)
      },
      {
        field: "report_name", headerName: "Test Details", flex: 0.43,
        renderCell: (params) => (<Box component={'div'}>
          {params?.row?.report_name ? params?.row?.report_name.length > 30 ?
            <Tooltip arrow placement='top' title={params?.row?.report_name}>
              <div>{params?.row?.report_name.slice(0, 30) + '...'}</div></Tooltip> : params?.row?.report_name : "-"}</Box>)
      },
      {
        field: "status", headerName: "Status", flex: 0.29, align: "left",
        renderCell: ({ row }) => {
          const imageFiles = row?.file_name || [];
          const pdfFiles = row?.pdf_file || [];
          const isPdf = imageFiles[0]?.result_img_url?.includes('.pdf');

          const handleViewClick = () => {
            if (imageFiles.length > 0) {
              this.setState(
                { isViewClicked: true, viewOpen: true, viewData: [], viewImage: null },
                () => this.renderImage(imageFiles, pdfFiles)
              );
            } else {
              this.errorMessage('No image to be viewed');
            }
          };

          const handlePdfClick = () => {
            if (imageFiles.length > 0) {
              this.setState(
                { viewData: [], viewImage: null },
                () => this.renderImage(imageFiles, true)
              );
            } else {
              this.errorMessage('No PDF to be viewed');
            }
          };
          return (
            <Box component={'div'} display={'flex'} alignItems={'center'} justifyContent={'center'} paddingRight={'0.5vw'}>
              {(row?.status === 'Result Inprogress') || (row?.status === "Specimen Collected") ?
                <Typography fontSize={'0.9vw'} fontWeight={600}>{row?.status ? row?.status : ""}</Typography>
                : ((row?.status === 'Result Delivered') || (row?.status === 'Result Completed')) ?
                  <Tooltip title={row?.is_outsource ? 'Outsource' : 'View'} placement="top" arrow>
                    <div>
                      <Button sx={{ textTransform: 'capitalize' }} className='Common_Btn_Min_Width'
                        disabled={row?.is_outsource}
                        onClick={() => { this.getFoLabTestReportPrint(row?.id, row?.laboratory_id)}}
                      >View</Button>
                    </div>
                  </Tooltip>
                  : (row?.status === 'Result Saved') || (row?.status === "In Progress") ? <Typography emed_tid={`test_reports_status_text_${row.id}`}>{row?.status}</Typography> :
                    (row?.status === 'Completed') ||  (row?.status === 'Dispatched') ?
                      <Tooltip title={row?.is_outsource ? 'Outsource' : 'View'} placement="top" arrow emed_tid={`test_reports_view_tooltip_${row.id}`}>
                        <div emed_tid={`test_reports_view_container_${row.id}`}>
                          <Button sx={{ textTransform: 'capitalize' }} className='Common_Btn_Min_Width'
                            disabled={row?.is_outsource}
                            onClick={() => { this.getFoRadiologyTestReportPrint(row?.id, row?.radiology_id) }}
                            emed_tid={`test_reports_view_btn_${row.id}`}
                          >View</Button>
                        </div>
                      </Tooltip> :
                  <Box display={"flex"} gap={"0.5vw"} alignItems={"center"}>
                    <Button sx={{ textTransform: 'capitalize' }} className="Common_Btn_Min_Width"
                      onClick={isPdf ? handlePdfClick : handleViewClick}>
                      {isPdf ? <FileUploadIcon color="primary" /> : 'View'}
                    </Button>
                    {(row?.is_deletable_item === true) && <CommonDeleteButton size={"1.5vw"} onClick={this.handleDelete.bind(this, row)} />}
                  </Box>
                  }
                  {!row?.is_deletable_item && (row?.status === 'Completed' || row?.status === 'Dispatched') ? this.moreActionOption(row) : null}
            </Box>)
        }
      }
    ]
    return (
      <Box component={'div'} className='eMed_insulin_left_card'>
        <DataGrid
          className='eMed_nur_notes_grid'
          rows={this.state.TestReportsData}
          page={this.state.page}
          pageSize={this.state.pageSize}
          columns={columns}
          headerHeight={40}
          getRowId={(row) => row?.sno}
          disableSelectionOnClick
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          initialState={{
            columns: {
              columnVisibilityModel: {
                created_by: false
              }
            }
          }}
          components={{
            Toolbar: CommonGridHeader.CommonToolBar,
            NoRowsOverlay: () => {
              return (
                <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "40vh" }}>
                  {t("NoRecordsFound")}
                </Stack>
              )
            }
          }}
          rowsPerPageOptions={[10, 20, 30]}
          pagination
          onPageChange={(newPage) => { this.setState({ page: newPage }) }}
          onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
        />
      </Box>
    )
  }

  handleAdd = () => {
    const { t } = this.props
    let { reportDetails, imgUpload, ipPatientData, date } = this.state;
    let isAvl = true;
    let Message = "";
    if (Object.keys(reportDetails).length === 0 && imgUpload.length === 0) { isAvl = false; Message = t("Fillmandatory") }
    else if (!reportDetails.report_type) { isAvl = false; Message = `${t("Enter")} ${t("ReportType")}` }
    else if (!date) { isAvl = false; Message = `${t("Enter")} ${t("Date")}` }
    else if (imgUpload.length === 0) { isAvl = false; Message = `${t("Select")} ${t("Files")}` }
    if (isAvl) {
      const dataForm = new FormData();
      dataForm.append("patient_id", ipPatientData.patient_id ? ipPatientData.patient_id : "");
      dataForm.append("appointment_id", "");
      dataForm.append("ip_admission_id", ipPatientData.id ? ipPatientData.id : "");
      dataForm.append("report_date", date ? DateTime.fromJSDate(date).toFormat('yyyy-MM-dd') : DateTime.fromJSDate(to_date).toFormat('yyyy-MM-dd'));
      dataForm.append("report_type", reportDetails.report_type ? reportDetails.report_type : "");
      dataForm.append("comment", reportDetails.comment ? reportDetails.comment : "");
      dataForm.append("clinic_id", this.state.clinic_id ? this.state.clinic_id : "");
      imgUpload.forEach((image) => {
        dataForm.append("report_file", image);
      });
      try {
        this.LoaderFunction(true)
        RestAPIService.create(dataForm, Serviceurls.FO_TEST_REPORT)
          .then(response => {
            if (response.data.status === "success") {
              this.ClearData();
              this.GetTestReports();
              this.LoaderFunction(false)
              this.successMessage(response.data.message);
            }
          })
          .catch(error => {
            if (error?.response?.data?.status === "fail") {
              this.LoaderFunction(false)
              this.errorMessage(error.response.data.message);
            }
          });
      } catch (e) {
        this.LoaderFunction(false)
        this.errorMessage(e.message);
      }
    } else {
      this.errorMessage(Message)
    }
  }

  ClearData() {
    // this.setState({
    //   fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    //   toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    //   dateIndex: 1,
    // })
    this.setState(
      {
        reportDetails: {},
        imgUpload: [],
        selectedImage: null,
        viewData: [],
        viewImage: null,
        date: to_date,
      })
  }

  onKeyDown = (e) => {
    e.preventDefault();
  };

  renderTextBox(label, statekey, value, width) {
    const { t } = this.props;
    let { reportDetails } = this.state;
    return (
      <div id="eMed_DocRepo_divs">
        {statekey === "report_type" ?
          <FormControl sx={{ width: width ? width : "20vw" }} size="small">
            <InputLabel>{t(label)}</InputLabel>
            <Select
              value={value ? value : ""}
              name={statekey}
              label={t(label) + "*"}
              onChange={(event) => {
                reportDetails["report_type"] = event.target.value;
                this.setState({
                  reportDetails
                })
              }}
              MenuProps={{
                style: { maxHeight: 350 },
              }}
            >
              {
                reportType?.length > 0 ? reportType.map((list, index) => (
                  <MenuItem key={index} value={list.value} >{list.label}</MenuItem>
                ))
                  : null
              }
            </Select>
          </FormControl>
          :
          statekey === "date" ?
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                inputFormat="dd-MM-yyyy"
                label={label ? t(label) : ""}
                name={statekey}
                value={value ? value : null}
                autoComplete="off"
                maxDate={DateTime.now()}
                onChange={
                  (value) => {
                    this.setState({
                      date: value
                    })
                  }
                }
                renderInput={(params) => <TextField onKeyDown={(e) => this.onKeyDown(e)} size="small" sx={{ width: width ? width : "14.5vw" }} {...params} onClick={() => { this.setState({ open: true }) }} />}
              />
            </LocalizationProvider>
            : <TextField
              label={label ? t(label) : ""}
              name={statekey}
              value={value ? value : ""}
              size="small"
              sx={{ width: width ? width : "14.5vw" }}
              multiline={statekey === "comment" ? true : false}
              rows={statekey === "comment" ? 3 : null}
              onChange={(event) => {
                reportDetails["comment"] = event.target.value.trimStart()
                this.setState({ reportDetails })
              }}
            />
        }
      </div>
    )
  }

  
  closeWebCamPop = () => {
    this.setState({
      imgCapClked: false,
      CapturedImg: null
    })
  }

  addImgCapture = (data) => {
    if (data) {
      this.setState((prevState) => ({
        imgUpload: [...prevState.imgUpload, dataURItoFile(data, `report_file_${Date.now()}.jpg`)],
        imgCapClked: false
      }));
    }
  }

  UploadButton = (onClick, imgSrc, text) => {
    const { t } = this.props;
    return (
      <Button sx={{ textTransform: "capitalize" }}
        disabled={(this.state.imgUpload.length === 6 || this.state.withOutAppointment?.is_op) ? true : false}
        onClick={onClick}>
        <Box
          component="div"
          borderRadius="10px"
          border="1px dotted gray"
          height="8vw"
          width="12vw"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Box component="img" src={imgSrc} height="2vw" width="2vw" />
          <Typography fontSize="0.9vw" color={Colors.SecondaryText} fontWeight={600} mt="0.5vw">
            {this.state.imgUpload.length === 6 ? t("MaxUpload") : text}
          </Typography>
        </Box>
      </Button>
    )
  };

  onImageRemove = (index) => {
    this.setState((prevState) => ({
      imgUpload: prevState.imgUpload.filter((_, i) => i !== index),
    }));
  };

  handleChange = async (e) => {
    const imageList = [];
    let imageFiles = [...e.target.files];
    let clearedArr = imageFiles?.filter((image, i) => {
      let file = image?.name;
      return String(file).toLowerCase() !== String(imageFiles[i + 1]?.name).toLowerCase()
    });
    // convert images to base64;
    for (let i = 0; i < clearedArr.length; i++) {
      imageList.push(clearedArr[i])
    }
    const newList = await Promise.all(imageList)
    this.setState((prevState) => ({
      imgUpload: [...prevState.imgUpload, ...newList]
    }))
  }

  renderImgCard = () => {
    let imageListLen = this.state.imgUpload.length;
    return (
      <Stack className="eMed_DocRepo_imgDiv" width = {"30dvw"} height = {"28vh"} justifyContent="center" alignItems="center"sx={{ backgroundColor: Colors.Background }}>
        <input
          type="file"
          multiple
          // accept="application/pdf, image/jpg, image/jpeg, image/png"
          accept="image/jpg, image/jpeg, image/png"
          onChange={this.handleChange}
          ref={this.uploadImage}
          style={{ display: "none"}}
        />
        <Stack direction="column" justifyContent="center" alignItems="center" spacing={1}>
          <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} gap={"0.5dvw"}>
            {this.UploadButton(() => { this.setState({ imgCapClked: true }) }, ImagePaths.CameraCapture.default, "Capture Image")}
            {this.UploadButton(() => this.uploadImage.current.click(), ImagePaths.LabUploadButton.default, "Browse Files")}
          </Box>
          {
            imageListLen > 0 ?
              <Stack className="eMed_Testrep_Img_item" direction="row" justifyContent={"center"} alignItems="center" marginTop={"0.3vw"}>
                {imageListLen > 0 && this.state.imgUpload.map((image, index) => (
                  <div key={index} className="eMed_Testrep_Img" style={{ marginRight: "0.5vw" }}>
                    <Tooltip title={typeof (image) === "string" ? null : image?.name} arrow placement='top'>
                      <img
                        onClick={() => {
                          if (typeof (image) === "string") {
                            if (image.split('.').pop() === "jpg" || image.split('.').pop() === "jpeg" || image.split('.').pop() === "JPG" || image.split('.').pop() === "png") {
                              this.setState({ isImgClicked: true, popUpOpen: true, selectedImage: image })
                            }
                            else {
                              window.open(image)
                            }
                          }
                        }}
                        src={typeof (image) === "string" ?
                          (image.split('.').pop() === "jpg" || image.split('.').pop() === "jpeg" || image.split('.').pop() === "JPG" || image.split('.').pop() === "png" ?
                            image : ImagePaths.DocumentPreview.default) : ((image?.type === "image/jpeg" || image?.type === "image/png") ? ImagePaths.ImagePreview.default : ImagePaths.DocumentPreview.default)}
                        className='eMed_Testrep_Img' /></Tooltip>
                    <div><IconButton id="eMed_Testrep_Icon" size="small"
                      onClick={() => {
                        this.setState({ selectedImage: null }, () => { this.onImageRemove(index) });
                      }}>
                      <CancelTwoToneIcon fontSize='small' color="error" />
                    </IconButton></div>
                  </div>
                ))}
              </Stack>
              : null
          }
        </Stack>
      </Stack>
    )
  }

  renderRightContent = () => {
    const { t } = this.props;
    let { reportDetails, date } = this.state;
    return (
      <Stack component={"div"}>
        <Paper>
          <Box component={'div'} height={'58vh'}>
            <Typography className='eMed_refdoc_title'>{t("TestReport")}</Typography>
            {/* <Box sx={{ width: "28vw", margin: '2vw' }}>
              <CommonDatePicker
                FromDate={this.state.fromDate}
                ToDate={this.state.toDate}
                DateIndex={this.state.dateIndex}
                SelectedDates={this.FilterDate.bind(this)}
                HideAllMenu={true} />
            </Box> */}
              <Box display={"flex"} flexDirection ={"column"} justifyContent={"center"} alignItems={"center"} marginX={"0.5dvw"}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                    {this.renderTextBox("SelectReportType", "report_type", reportDetails["report_type"], "17vw")}
                    {this.renderTextBox("", "date", date, "12vw")}
                  </Stack>
                  {this.renderTextBox("TestDetails", "comment", reportDetails["comment"], "30vw")}
                  {this.renderImgCard()}
              </Box>   
          </Box>
          <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"}>
            <Button emed_tid={"IP_test_report_clear"} variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.ClearData() }}>{t("Clear")}</Button>
            <Button
              emed_tid={"IP_test_report_search"}
              disabled={!CheckAccessFunc("front_office", "In Patients", "Reports", "Test Report", "SubTab")?.editAccess}
              variant='contained' size="small" id="eMed_Config_btn" onClick={this.handleAdd}>{t("Add")}</Button>
          </Stack>
        </Paper>
      </Stack>
    )
  }

  render() {
    const { t } = this.props
    const { ipPatientData, viewData, viewOpen } = this.state
    let attender = {
      lineOne: t("AttenderName"),
      lineTwo: `${ipPatientData.attender_name ? ipPatientData.attender_name : '-'}`,
      lineFour: t('ContactNumber'),
      LineFive: `${ipPatientData.attender_mobile ? ipPatientData.attender_mobile : '-'}`
    }
    let consultant = {
      lineOne: t("ConsultantName"),
      lineTwo: `${ipPatientData.doctor_name ? ipPatientData.doctor_name : '-'}`,
    }
    return (
      <Box sx={{ backgroundColor: Colors.ComponentBgColor }}>
        <Box component={'div'} marginLeft={'0.5vw'} className='eMed_patient_header'>
          <Box display={'flex'} alignItems='center'>
            <Box className='eMed_Patient_Details_Long eMed_patient_box'>
              <CommonPatientDetails data={this.state.ipPatientData} showDetailed={true} />
            </Box>
            <CommonPatientCard details={attender} showDetailed={true} />
            <ConsultantPatientCard name={consultant} />
          </Box>
        </Box>
        <Box display={'flex'} flexDirection={'row'} marginTop={"0.5vw"}>
          <Card elevation={3} className='eMed_DocNotes_Left_Main'>
            {this.renderLeftContent()}
          </Card>
          <Paper elevation={3} className='eMed_DocNotes_Right_Main' sx={{ height: "63.8vh" }}>
            {this.renderRightContent()}
          </Paper>
        </Box>
        <Loader loaderOpen={this.state.isLoader} />
        {
          this.state.imgCapClked && <OpenWebCamPopUP
            capturedImg={this.state.CapturedImg}
            closePopup={this.closeWebCamPop.bind(this)}
            addImgCapture={this.addImgCapture.bind(this)}
          />
        }
        {
          this.state.isViewClicked && viewData.length > 0 ?
            <Modal open={viewOpen}>
              <Box id="eMed_DocRepo_popup">
                <Stack id="eMed_DocRepo_popupDiv" direction="column" justifyContent="center" alignItems="center" p={2}>
                  <Stack id="eMed_DocRepo_popupClose" direction="row" justifyContent="flex-end" alignItems="center">
                    <IconButton size="small" onClick={this.popUpViewClose} pr={2}>
                      <img className="eMed_DocRepo_popupIcon" src={ImagePaths.LabCloseButton.default} alt={"close"} />
                    </IconButton>
                  </Stack>
                  <Stack className="eMed_DocRepo_img" justifyContent="center" alignItems="center">
                    {this.state.viewImage.type === "pdf" ?
                      <Box display={'flex'} alignItems={'center'} flexDirection={'column'}>
                        <img style={{ width: '12vw', height: '12vw' }} src={ImagePaths.DocumentPreview.default} alt="slide" />
                        <Button variant="contained" onClick={() => { window.open(this.state.viewImage.data_url) }}>Download Document</Button>
                      </Box>
                      : <img className="eMed_DocRepo_img" src={this.state.viewImage.data_url ? this.state.viewImage.data_url : ""} alt="slide" style={{ overflow: "hidden" }} />}
                  </Stack>
                  <Stack className="eMed_testrp_div" direction="row" justifyContent="space-between" alignItems="center">
                    <IconButton size="small" className="eMed_testrp_arrow" onClick={() => { this.prevImage(this.state.currentIndex) }}><KeyboardDoubleArrowLeftIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" /></IconButton>
                    <IconButton size="small" className="eMed_testrp_arrow" onClick={() => { this.nextImage(this.state.currentIndex) }}><KeyboardDoubleArrowRightIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" /></IconButton>
                  </Stack>
                </Stack>
              </Box>
            </Modal>
            : null
        }
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.deletedPopup ? <DeletePopup
          DeletTitle={`${t("deleteMsg")} ?`}
          deleteAlertPopupClose={this.PopupClose.bind(this)}
          removeData={this.removeDataList.bind(this)}
        /> : null}
        {this.state.printPreviewPop ?
          <PrintPreviewPop
            Data={this.state.printPreviewData}
            Title={this.state.pdfName}
            BillData={this.state.selectedRow}
            ClosePopUp={() => { this.closePrintPreview() }}
            history={this.props.history}
          /> : null}
      </Box>
    )
  }
}

export default withTranslation()(IPTestReports)